import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login/login'
//import Index from '@/view/index/index'
import Index from '@/view/index/lzindex'
import Information from '@/view/information/information'

import ClassList from '@/view/class/class'

import Entrepreneurship from '@/view/entrepreneurship/entrepreneurship'
import Employment from '@/view/employment/employment'
// import myStudy from '@/view/myStudy'
import Personal from '@/view/personal/personal'
import CourseInfo from '@/view/index/course/courseInfo'      //旧
//import CourseInfo from '@/view/index/course/learncourse'        //新

import Lesson from '@/view/index/course/lesson'                //旧
// import Lesson from '@/view/index/course/newlesson'              //新
import MenuPage from '@/view/index/course/menuPage'

//人脸识别
import FaceRecognition from '../../src/components/FaceRecognition'
import ClearAll from '@/view/clearAll'
import webdebug from '@/view/webdebug'
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/',
            alias: '/index',
            name: 'index',
            component: Index,
            meta: {
                title: '职业培训平台',
                keepAlive: true, // 需要被缓存
            }
        },
        {
            path: '/register',
            name: 'register',
            component: resolve => require(['@/view/login/register'], resolve)
        },
        {
            path: '/register4School',
            name: 'register4School',
            component: resolve => require(['@/view/login/register4School'], resolve)
        },
        {
            path: '/forgetpwd',
            name: 'forget password',
            component: resolve => require(['@/view/login/fogetPassword'], resolve)
        },
        {
            path: '/exam/start',
            component: resolve => require(['@/view/exam/start'], resolve)
        },
        {
            path: '/exam/test',
            alias: '/exam',
            component: resolve => require(['@/view/exam/exam'], resolve)
        },
        {
            path: '/exam/idverify',
            component: resolve => require(['@/view/exam/idverify'], resolve)
        },
        {
            path: '/exam/idverify4Unit',
            component: resolve => require(['@/view/exam/idverify4Unit'], resolve)
        },
        {
            path: '/exam/point',
            component: resolve => require(['@/view/exam/point'], resolve)
        },
        {
            path: '/exam/errors',
            component: resolve => require(['@/view/exam/errors'], resolve)
        },
        {
            path: '/information',
            name: 'information',
            component: Information
        },
        {
            path: '/information/detail',
            component: resolve => require(['@/view/information/infoDetail'], resolve)
        },
        {
            path: '/information/more',
            component: resolve => require(['@/view/information/more'], resolve)
        },
        {
            path: '/information/comment',
            component: resolve => require(['@/view/information/comment'], resolve)
        },
        {
            path: '/entrepreneurship',
            name: 'entrepreneurship',
            component: Entrepreneurship
        },
        {
            path: '/employment',
            name: 'employment',
            component: Employment
        },
        {
            path: '/personal',
            name: 'personal',
            component: Personal
        },
        {
            path: '/personal/returnVisit',
            name: 'personal-returnvisit',
            component: resolve => require(['@/view/personal/myReturnVisit'], resolve)
        },
        {
            path: '/personal/setting',
            name: 'personal-setting',
            component: resolve => require(['@/view/personal/setting'], resolve)
        },
        {
            path: '/personal/setting/account',
            name: 'personal-setting-account',
            component: resolve => require(['@/view/personal/settingAccount'], resolve)
        },
        {
            path: '/personal/setting/password/change',
            name: 'personal-setting-changePassword',
            component: resolve =>
                require(['@/view/personal/settingPassword'], resolve)
        },
        {
            path: '/personal/setting/password/forget',
            name: 'personal-setting-forgetPassword',
            component: resolve =>
                require(['@/view/personal/settingPassword2'], resolve)
        },
        {
            path: '/personal/setting/message',
            alias: '/personal/setting/notice',
            name: 'personal-setting-message',
            component: resolve => require(['@/view/personal/myNotice'], resolve)
        },
        {
            path: '/personal/setting/complete',
            name: 'personal-setting-complete',
            component: resolve => require(['@/view/personal/complete'], resolve)
        },{
            path: '/personal/setting/jionCode',
            name: 'personal-setting-jionCode',
            component: resolve => require(['@/view/personal/jionCode'], resolve)
        },
        {
            path: '/personal/setting/complete/selection',
            name: 'personal-setting-complete-selection',
            component: resolve => require(['@/view/personal/selection'], resolve)
        },
        {
            path: '/personal/setting/fqa',
            name: 'personal-setting-fqa',
            component: resolve => require(['@/view/personal/fqa'], resolve)
        },
        {
            path: '/personal/setting/suggesion',
            name: 'personal-setting-suggesion',
            component: resolve => require(['@/view/personal/mySuggestion'], resolve)
        },
        {
            path: '/personal/setting/about',
            name: 'personal-setting-about',
            component: resolve => require(['@/view/personal/about'], resolve)
        },
        {
            path: '/personal/school/list',
            name: 'personal-school-list',
            component: resolve => require(['@/view/personal/schoolList'], resolve)
        },
        {
            path: '/personal/school/detail',
            name: 'personal-school-detail',
            component: resolve => require(['@/view/personal/schoolDetail'], resolve)
        },
        {
            path: '/personal/school/region',
            name: 'personal-school-region',
            component: resolve => require(['@/view/personal/region'], resolve)
        },
        {
            path: '/personal/school/courseListInfo',
            name: 'personal-school-courseListInfo',
            component: resolve => require(['@/view/personal/courseListInfo'], resolve)
        },
        {
            path: '/personal/school/punchcard',
            name: 'personal-school-punchcard',
            component: resolve => require(['@/view/personal/punchCard'], resolve)
        },{
            path: '/personal/school/punchCardPlus',
            name: 'personal-school-punchCardPlus',
            component: resolve => require(['@/view/personal/punchCardPlus'], resolve)
        },
        {
            path: '/personal/school/punchcards',
            name: 'personal-school-punchcards',
            component: resolve => require(['@/view/personal/punchCards'], resolve)
        },
        /* {
             path: '/personal/school/punchCardMarkUpLog',
             name: 'personal-school-punchCardMarkUpLog',
             component: resolve => require(['@/view/personal/punchCardMarkUpLog'], resolve)
         },*/
        {
            path: '/personal/school/punchhistory',
            name: 'personal-school-punchhistory',
            component: resolve => require(['@/view/personal/punchHistory'], resolve)
        },
        {
            path: '/personal/credit/main',
            name: 'personal-credit-main',
            component: resolve => require(['@/view/personal/creditMain'], resolve)
        },
        {
            path: '/personal/credit/description',
            name: 'personal-credit-description',
            component: resolve => require(['@/view/personal/creditDescription'], resolve)
        },
        {
            path: '/personal/credit/detailed',
            name: 'personal-credit-detailed',
            component: resolve => require(['@/view/personal/creditDetailed'], resolve)
        },
        {
            path: '/personal/credit/exchange',
            name: 'personal-credit-exchange',
            component: resolve => require(['@/view/personal/creditExchange'], resolve)
        },
        {
            path: '/personal/teacher/teacher',
            name: 'personal-teacher-index',
            component: resolve => require(['@/view/personal/teacher/teacher'], resolve)
        },
        {
            path: '/personal/teacher/myTeaching',
            name: 'myTeaching',
            component: resolve => require(['@/view/personal/teacher/myTeaching'], resolve)
        },
        {
            path: '/personal/teacher/myTeachingWork',
            name: 'myTeachingWork',
            component: resolve => require(['@/view/personal/teacher/myTeachingWork'], resolve)
        },
        {
            path: '/personal/teacher/teacherPunchCard',
            name: 'teacherPunchCard',
            component: resolve => require(['@/view/personal/teacher/teacherPunchCard'], resolve)
        },
        {
            path: '/personal/teacher/punchTeacherHistory',
            name: 'punchTeacherHistory',
            component: resolve => require(['@/view/personal/teacher/punchTeacherHistory'], resolve)
        },
        {
            path: '/index/workerInfo',
            component: resolve => require(['@/view/index/course/workerInfo'], resolve)
        },
        {
            path: '/personal/teacher/myTeachClass',
            name: 'personal-teacher-teachclass',
            component: resolve => require(['@/view/personal/teacher/myTeachClass'], resolve)
        },
        {
            path: '/personal/teacher/studentInGroup',
            name: 'studentInGroup',
            component: resolve => require(['@/view/personal/teacher/studentInGroup'], resolve)
        },
        {
            path: '/personal/teacher/studentSignInRecord',
            name: 'studentsigninrecord',
            component: resolve => require(['@/view/personal/teacher/studentSignInRecord'], resolve)
        },
        {
            path: '/personal/teacher/attendanceMain',
            name: 'attendanceMain',
            component: resolve => require(['@/view/personal/teacher/attendanceMain'], resolve)
        },
        {
            path: '/personal/teacher/mySchoolDetail',
            name: 'mySchoolDetail',
            component: resolve => require(['@/view/personal/teacher/mySchoolDetail'], resolve)
        },
        {
            path: '/personal/teacher/videoCall',
            name: 'videoCall',
            component: resolve => require(['@/view/personal/teacher/videoCall'], resolve)
        },
        // {
        //   path: '/myStudy',
        //   name: 'myStudy',
        //   component: myStudy
        // },
        {
            path: '/index/courseInfo',
            name: 'courseInfo',
            component: CourseInfo
        },
        {
            path: '/webdebug',
            name: 'webdebug',
            component: webdebug
        },
        {
            path: '/index/menuPage',
            name: 'menuPage',
            component: MenuPage
        },
        {
            path: '/course/lesson',
            name: 'lesson',
            component: Lesson,
        },
        {
            path: '/clearAll',
            name: 'clearAll',
            component: ClearAll
        },
        {
            path: '/classList',
            name: 'classList',
            component: ClassList
        },
        //人脸识别
        {
            path: '/FaceRecognition',
            name: 'FaceRecognition',
            component: FaceRecognition
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js